import React, { useState } from "react";
import CtaComponent from "./cta.component";
import { Spin } from "antd";

const CtaContainer = () => {
  const [spinning, setSpinning] = useState(false);
  return (
    <div>
      <Spin spinning={spinning}>
        <CtaComponent />
      </Spin>
    </div>
  );
};

export default CtaContainer;
